import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
// OBTIENER LISTADO DE BANCOS
export const getInventario = async(mes, anio) => {
    console.log(`Suministro/Inventario/InventarioMesAnio/${mes}/${anio}`)
    const result = await PrivateInterceptor(`Suministro/Inventario/InventarioMesAnio/${mes}/${anio}/1`, 'GET')
    return result;
}

export const getTomaInventarioDates = async(dates) => {
    const result = await PrivateInterceptor(`Suministro/Inventario/tomaInventarioDates/1`, 'POST', dates);
    return result;
}

export const getTomaInventarioAgrupado = async(dates, IdReferencia) =>{
   const result = await PrivateInterceptor(`Suministro/Inventario/TomaInventarioAgrupada`, 'POST',{FechaInicio: dates[0], FechaFinal: dates[1], IdReferencia})
   return result
}
